import { render, staticRenderFns } from "./UnauthorizedAccess.vue?vue&type=template&id=6498ec7e&"
import script from "./UnauthorizedAccess.vue?vue&type=script&lang=ts&"
export * from "./UnauthorizedAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports